import IonInput from './src/ion-input.vue';

IonInput.install = function install(_vue) {
  _vue.component(IonInput.name, IonInput);
};
export default IonInput;
